import { render, staticRenderFns } from "./site-instant-charge-container.vue?vue&type=template&id=b3fa3ba2&scoped=true&"
import script from "./site-instant-charge-container.vue?vue&type=script&lang=js&"
export * from "./site-instant-charge-container.vue?vue&type=script&lang=js&"
import style0 from "./site-instant-charge-container.vue?vue&type=style&index=0&id=b3fa3ba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fa3ba2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
